var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 7.33334L7.76197 8.97616C7.91892 9.2116 8.02413 9.47766 8.07065 9.75676L9.86081 20.4977C9.94118 20.9799 10.3584 21.3333 10.8472 21.3333H22.4661C22.9638 21.3333 23.3857 20.9674 23.4561 20.4748L24.6341 12.2283C24.6513 12.1078 24.5579 12 24.4361 12H8.44453M12.6667 16H15.3334M21.3334 24.6667C22.0698 23.9303 22.0698 22.7364 21.3334 22C20.597 21.2636 19.4031 21.2636 18.6667 22C17.9304 22.7364 17.9304 23.9303 18.6667 24.6667C19.4031 25.403 20.597 25.403 21.3334 24.6667ZM13.3334 24.6667C14.0698 23.9303 14.0698 22.7364 13.3334 22C12.597 21.2636 11.4031 21.2636 10.6667 22C9.93037 22.7364 9.93037 23.9303 10.6667 24.6667C11.4031 25.403 12.597 25.403 13.3334 24.6667Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartWhite);
export default __webpack_public_path__ + "static/media/cart_white.a8d511ff3bec87530906522f68fe141a.svg";
export { ForwardRef as ReactComponent };